import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page11() {
  useEffect(() => {
    document.title = "Маяк — Страница 10"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page9" />
        <ForwardLink href="/page11" />
      </div>

      <p style={{ textAlign: "right" }}>10.</p>
      <p>
        ФОГОРН РЕВЕТ СНОВА! МОЛОДОЙ ПИНАЕТ СТУЛ...<br/>
        РУКОВОДСТВО ПАДАЕТ НА ЗЕМЛЮ.
      </p>
      <br/>
      <p>ВНУТРИ. МАЯК. ЛЕСТНИЦА БАШНИ – НОЧЬ</p>
      <p>МУЗЫКАЛЬНАЯ ВСТАВКА: Странная, навязчивая, древняя.</p>
      <p>КАМЕРА ПОДНИМАЕТСЯ ВВЕРХ ЧЕРЕЗ: Звон и лязг шестеренок часового механизма маяка...</p>
      <p>
        Тяжелая свинцовая гиря на цепи медленно поднимается вверх через<br/>
        центр чугунной спиральной лестницы башни...
      </p>
      <p>
        Чудесные узоры кружащегося света движутся<br/>
        по железной конструкции.
      </p>
      <p>Узоры меняются ритмично -- гипнотически.</p>
      <p>Потусторонне.</p>
      <br/>
      <p>ВНУТРИ. МАЯК. ФОНАРНОЕ ОТДЕЛЕНИЕ – НОЧЬ</p>
      <p>МУЗЫКА ПРОДОЛЖАЕТ ИГРАТЬ.</p>
      <p>
        СТАРИК сидит в поту, загипнотизированный СВЕТОМ. Механизм<br/>
        шумит и щелкает. Сильное ТЕПЛО из огромной ТРЕТЬЕЙ ФРЕНЕЛЕВОЙ ЛИНЗЫ.<br/>
        Он окружен ореолом дыма своей трубки.
      </p>
      <p>Он снял куртку...</p>
      <p>Не холодно.</p>
      <p>Он растегивает свой профсоюзный костюм...</p>
      <p>– ПОЗЖЕ</p>
      <p>
        Теперь он по пояс голый. На его жилистом теле торчат<br/>
        кишки алкоголика. Его сильные, жилистые руки блестят от пота. На его груди<br/>
        выцветшая татуировка трехмачтового судна, и несколько<br/>
        кривых палочек и точек по всему телу -- все блестит.
      </p>
      <p>
        Он наливает грог (ром, разбавленный водой) в свою жестяную чашку. Поднимает тост<br/>
        за свет. Выпивает.
      </p>
      <p>Его глаза тяжелеют.</p>
      <p>Он еще не пьяный. Но он хочет опьянеть.</p>
      <p>Он наливает еще одну.</p>
      <p>Поднимает тост.</p>
      <p style={{ textAlign: "right" }}>10.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page9" />
        <ForwardLink href="/page11" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1708106507/the-lighthouse-script/liz9fnpgd0izx6iwpo1y.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page11;
